import React from 'react';
import { countryNameToFlagEmoji } from 'src/shared/data/countries';

const NOT_SET = '—';

type CountryCellProps = {
    country: string;
};

/** Names a sampling country, with its flag where one is known. */
const CountryCell = ({ country }: CountryCellProps) => {
    const flag = countryNameToFlagEmoji(country);

    return (
        <span className='flex items-center gap-1'>
            {/* Hidden from screen readers, which would otherwise read the country twice. */}
            {flag && <span aria-hidden>{flag}</span>}
            <span>{country || NOT_SET}</span>
        </span>
    );
};

export default CountryCell;
